import { CreateBillingAddressField } from '@app/plans/src/PlanPurchaseFormAddressElement/CreateBillingAddressField'
import { PaymentElementError } from '@app/plans/src/PaymentElementError/PaymentElementError'
import { useEffect, useRef } from 'react'
import { useInternalPlanPurchaseFormContext } from '../PlanPurchaseForm/context/useInternalPlanPurchaseFormContext'

export interface PlanPurchaseFormPaymentElementProps {
  heapId: string
  helperText?: string
}

export function PlanPurchaseFormAddressElement({
  heapId,
  helperText
}: PlanPurchaseFormPaymentElementProps): JSX.Element {
  const { form, paymentMethodType } = useInternalPlanPurchaseFormContext()
  const {
    formState: { errors },
    setValue,
    setError
  } = form

  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (
      errors.billingDetails?.message &&
      containerRef.current &&
      containerRef.current.scrollIntoView
    ) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [containerRef, errors.billingDetails?.message])
  return (
    <>
      <CreateBillingAddressField
        heapId={heapId}
        paymentMethodType={paymentMethodType}
        onChange={event => {
          setValue('billingDetails', { address: event.value.address, name: event.value.name })
        }}
        onFocus={() => {
          setError('billingDetails', {})
        }}
      />
      <PaymentElementError errorMessage={errors.billingDetails?.message} helperText={helperText} />
    </>
  )
}
